import './styles.scss';

export default {
    name: 'MessagingAvailableMessagesPage',

    data() {
        return {
            list: [
                {
                    id: 1,
                    title: 'Active shooter reported outside building. Shelter in place. Access INTO building restricted.'
                },
                {
                    id: 2,
                    title: 'Armed intruder - Lockdown immediately.'
                },
                {
                    id: 3,
                    title: 'Disregard previous alert. There is NO emergency.'
                },
                {
                    id: 4,
                    title: 'Evacuate down to next re-entry floor.'
                },
                {
                    id: 5,
                    title: 'Please exit building immediately.'
                },
                {
                    id: 6,
                    title: 'Severe weather - Take cover immediately.'
                }
            ]
        };
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages/choose-message'
        });
    },

    methods: {
        update(item) {
            this.$store.commit('setMessage', item.title);

            this.$router.push('/action/emergency-messages/compose-message');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};